import React, { lazy } from 'react';
import { permission } from '../constants/permission';
import {
  IconDashboardChangePassword,
  IconExecution,
  IconLocateSearch,
} from '../styles/svg/svgIcons';
import { IconPortfolioAnalytics } from '../styles/svg/svgIcons';
import { IconAccountSettingsGear, IconOperations } from '../styles/svg/svgIcons';
import { IconExeP2P } from '../styles/svg/svgIcons';
import LoginComponent from '../pages/Login/loginComponent';
import ProtectedRoutes from './ProtectedRoutes';
import { PortfolioAnalytics } from '../styles/svg/productMenu/svgIcons';
import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComputer } from '@fortawesome/free-solid-svg-icons';

const Dashboard = lazy(() => import('../pages/SwapsTek/Dashboard'));
const OrderEntry = lazy(() => import('../pages/OrderEntryForm/OrderEntryForm'));
const OrderDetails = lazy(() => import('../pages/SwapsTek/OrderDetails/OrderDetailsComponent'));
const Substitution = lazy(() => import('../pages/SwapsTek/Substitution/SubstitutionComponent'));
const Amendment = lazy(() => import('../pages/SwapsTek/Amendment/AmendmentComponent'));
const ChangePassword = lazy(() => import('../pages/changePassword/ChangePasswordComponent'));
const ForgotPassword = lazy(() => import('../pages/forgotPassword/forgotPasswordComponent'));
const AccountSettings = lazy(() => import('../pages/AccountSettings/AccountSettingsComponent'));
const LogoutModal = lazy(() => import('../pages/Logout/LogoutModalComponent'));
const SwapBaskets = lazy(() => import('../pages/SwapBaskets/SwapBasketsComponent'));
const AuditTrail = lazy(() => import('../pages/SwapsTek/AuditTrail/AuditTrailComponent'));
const AccessDenied = lazy(() => import('../pages/accessDenied/accessDeniedComponent'));

export const paths = {
  accessDenied: '/404',
  accountSettings: '/account-settings',
  organizationSetup: '/organization-setup',
  userSetup: '/user-setup',
  logoutModal: '/logout',
  changePassword: '/change-password',
  swapBasket: '/swap-baskets',
  ErrorHandler: '/error',
  forgotPassword: '/forgot-password',
  login: '/login',
  resetPassword: '/reset-password/:resetToken',
  dashboard: '/dashboard',
  orderEntry: '/order-entry',
  orderDetails: '/order-details',
  substitution: '/substitution',
  amendment: '/amendment',
  auditTrail: '/audit-trail',
  exceptionQueue: '/exception-queue',
};

export const publicRoutes = [
  {
    path: paths.login,
    element: <LoginComponent />,
  },
  {
    path: paths.forgotPassword,
    element: <ForgotPassword />,
  },
  {
    path: paths.resetPassword,
    element: <ForgotPassword />,
  },
  {
    path: paths.accessDenied,
    element: <AccessDenied />,
  },
  {
    path: paths.logoutModal,
    element: <LogoutModal />,
  },
  {
    path: '*',
    element: <Navigate to={paths.accessDenied} replace />,
  },
];

export const privateRoutes = {
  element: <ProtectedRoutes />,
  children: [
    {
      path: paths.accountSettings,
      element: <AccountSettings />,
    },
    {
      path: paths.organizationSetup,
      element: <AccountSettings />,
    },
    {
      path: paths.userSetup,
      element: <AccountSettings />,
    },
    {
      path: paths.changePassword,
      element: <ChangePassword />,
    },
    {
      path: paths.swapBasket,
      element: <SwapBaskets />,
    },
    {
      path: paths.dashboard,
      element: <Dashboard />,
    },
    {
      path: paths.orderEntry,
      element: <OrderEntry />,
    },
    {
      path: paths.orderDetails,
      element: <OrderDetails />,
    },
    {
      path: paths.substitution,
      element: <Substitution />,
    },
    {
      path: paths.amendment,
      element: <Amendment />,
    },
    {
      path: paths.auditTrail,
      element: <AuditTrail />,
    },
    // {
    //   path: paths.exceptionQueue,
    //   element: <ExceptionQueue />,
    // },
  ],
};

export interface RouteConfig {
  id: string;
  isBeta: boolean;
  isDemo: boolean;
  isSoon: boolean;
  isAggregate?: boolean;
  label: string;
  labelTooltip?: string;
  navigationMenuIcon: any;
  path: string;
  productMenuIcon: any;
  configSpecific?: any;
  notApplicableForMultiTenants?: boolean;
  permission: string[];
}

interface protectedRouteListInterface {
  [key: string]: RouteConfig;
}

export const protectedRouteList: protectedRouteListInterface = {
  accountSettings: {
    id: 'accountSettings',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'Account Settings',
    navigationMenuIcon: <IconAccountSettingsGear />,
    path: paths.accountSettings,
    productMenuIcon: <IconAccountSettingsGear />,
    permission: [permission.READ_ORG_SETUP, permission.WRITE_ORG_SETUP, permission.WRITE_USER],
  },
  organizationSetup: {
    id: 'organizationSetup',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'Organization Setup',
    navigationMenuIcon: <IconAccountSettingsGear />,
    path: paths.organizationSetup,
    productMenuIcon: <IconAccountSettingsGear />,
    permission: [permission.READ_ORG_SETUP, permission.WRITE_ORG_SETUP],
  },
  userSetup: {
    id: 'userSetup',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'User Setup',
    navigationMenuIcon: <IconAccountSettingsGear />,
    path: paths.userSetup,
    productMenuIcon: <IconAccountSettingsGear />,
    permission: [permission.WRITE_USER],
  },
  changePassword: {
    id: 'changePassword',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'Change Password',
    navigationMenuIcon: null,
    path: paths.changePassword,
    productMenuIcon: <IconDashboardChangePassword />,
    permission: [],
  },
  swapBaskets: {
    id: 'inventoryAndBaskets',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'Inventory & Basket',
    navigationMenuIcon: <IconExecution />,
    path: paths.swapBasket,
    productMenuIcon: <IconExecution />,
    permission: [permission.READ_BNY, permission.WRITE_BNY],
  },
  execution: {
    id: 'execution',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'Execution',
    navigationMenuIcon: <IconExecution />,
    path: '',
    productMenuIcon: null,
    permission: [],
  },
  portfolioAnalytics: {
    id: 'portfolioAnalytics',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'Portfolio Analytics',
    navigationMenuIcon: <IconPortfolioAnalytics />,
    path: '',
    productMenuIcon: <PortfolioAnalytics />,
    permission: [],
  },
  dashboard: {
    id: 'dashboard',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'Dashboard',
    navigationMenuIcon: <IconOperations />,
    path: paths.dashboard,
    productMenuIcon: <IconExeP2P />,
    permission: [permission.READ_BNY, permission.WRITE_BNY],
  },
  orderEntry: {
    id: 'orderEntry',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'Order Entry',
    navigationMenuIcon: <IconLocateSearch />,
    path: paths.orderEntry,
    productMenuIcon: <IconLocateSearch />,
    permission: [permission.WRITE_BNY],
  },
  amendment: {
    id: 'amendment',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'Amendment',
    navigationMenuIcon: null,
    path: paths.amendment,
    productMenuIcon: null,
    permission: [permission.WRITE_BNY],
  },
  substitution: {
    id: 'substitution',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'Substitution',
    navigationMenuIcon: null,
    path: paths.substitution,
    productMenuIcon: null,
    permission: [permission.WRITE_BNY],
  },
  auditTrail: {
    id: 'auditTrail',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'Audit Trail',
    navigationMenuIcon: null,
    path: paths.auditTrail,
    productMenuIcon: null,
    permission: [permission.READ_BNY, permission.WRITE_BNY],
  },
  exceptionQueue: {
    id: 'exceptionQueue',
    isBeta: false,
    isDemo: true,
    isSoon: false,
    label: 'Exceptions Monitor',
    navigationMenuIcon: <FontAwesomeIcon icon={faComputer} size="lg" />,
    path: paths.exceptionQueue,
    productMenuIcon: null,
    permission: [permission.READ_EXCEPTION_QUEUE],
  },
};
